export function trimObjectStringProperties(obj: { [key: string]: any }) {
  return Object.entries(obj).reduce((acc, [k, v]) => {
    acc[k] = typeof v === "string" ? v.trim() : v;
    return acc;
  }, {} as { [key: string]: any });
}
